import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')
// 初期化
export const home = () => {
    return http.requestQuickGet(apiUrl.apiUrl_Initialization)
}

// マスタデータ
export const conditionSearch = (page, div, type) => {
  let querys = querystring.stringify({ type: type })
  return http.requestQuickGet(apiUrl.apiurl_masterData + '/' + page + '/' + div + '?' + querys)
}

// 対象年月取得
export const k_0003_targetYm = () => {
    return http.requestGet(apiUrl.apiUrl_StaffTargetYm)
}
// スタッフ時給取得
export const k_0003_hourwage = (params) => {
    let querys = querystring.stringify(params)
    return http.requestGet(apiUrl.apiUrl_StaffHourwage + '?' + querys)
}
// 各手当時給情報取得
export const k_0003_typeAllowance = (params) => {
  let querys = querystring.stringify(params)
  return http.requestGet(apiUrl.apiUrl_StaffTypeAllowance + '?' + querys)
}

// 時給合計情報取得
export const k_0003_totalAllowance = (params) => {
  let querys = querystring.stringify(params)
  return http.requestGet(apiUrl.apiUrl_StaffTotalAllowance + '?' + querys)
}

// スタッフ案件手当取得
export const k_0003_allowance = (params) => {
    let querys = querystring.stringify(params)
    return http.requestGet(apiUrl.apiUrl_StaffAllowance + '?' + querys)
}


// WEBPACK FOOTER //
// ./src/module/api/k_0003.js